import React from "react";
import GrComponentFactory from "../../gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "ReadStatusHeader",

  propTypes: {
    headerText: React.PropTypes.string.isRequired,
  },

  render(){
    return (
      <span>{this.props.headerText}</span>
    );
  },
});
